import { DashboardLayout } from "admin/components/layout/components/DashboardLayout";
import { Navbar } from "admin/components/layout/components/Navbar";
import { CampaignsTable } from "../components/CampaignsTable";
import { hasPermission } from "utils/hasPermission";
import { useGetUserInfo } from "hooks/useGetUserInfo";

export const AdminCampaigns = () => {
  const { userInfo } = useGetUserInfo();
  const canView = ["View Campaigns", "Manage Campaigns"].some((p) =>
    hasPermission(userInfo, p)
  );

  return (
    <DashboardLayout>
      <Navbar
        title="Campaigns"
        description="Marketing tracking links and signup attribution"
      />
      <div className="mt-4">
        {canView ? (
          <CampaignsTable />
        ) : (
          <p className="text-gray-600">
            You do not have permission to view campaigns.
          </p>
        )}
      </div>
    </DashboardLayout>
  );
};
